import { createContext } from 'react'

import { ContextProps, defaultState } from './index'

const Context = createContext<ContextProps>({
  state: defaultState,
  setState: () => {},
})

export { Context }
